<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('auditOpenShop.title') }}</div>
      </div>
      <div class="">
        <el-table :data="auditOpenShopInfo.shops" style="width: 100%" border stripe size="medium">
          <el-table-column prop="shopLogo" :label="$t('auditOpenShop.shopLogo')" align="center" width="120">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="scope.row.shopLogo"
                fit="cover"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="shopName" :label="$t('auditOpenShop.shopName')" align="center"></el-table-column>
          <el-table-column prop="shopTypeName" :label="$t('auditOpenShop.shopType')" align="center"></el-table-column>
          <el-table-column prop="storeName" :label="$t('auditOpenShop.storeName')" align="center"></el-table-column>
          <el-table-column prop="storeAddress" :label="$t('auditOpenShop.storeAddress')"
            align="center"></el-table-column>
          <el-table-column prop="storeTel" :label="$t('auditOpenShop.storeTel')" align="center"></el-table-column>
          <el-table-column prop="stateName" :label="$t('auditOpenShop.state')" align="center"></el-table-column>
          <el-table-column :label="$t('auditOpenShop.operation')" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="scope.row.state !== '002'" type="primary" size="mini"
                @click="_openAuditOpenShopModel(scope.row)">
                {{ $t('auditOpenShop.audit') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="auditOpenShopInfo.conditions.page"
          :page-size="DEFAULT_ROWS" layout="total, prev, pager, next" :total="auditOpenShopInfo.total"
          class="pagination"></el-pagination>
      </div>
    </el-card>

    <audit-component ref="auditComponent" @auditNotify="_auditOrderInfo"></audit-component>
  </div>
</template>

<script>
import { queryNeedAuditShop, auditShop } from '@/api/admin/auditOpenShopApi'
import AuditComponent from '@/components/common/audit/Audit'

export default {
  name: 'AuditOpenShop',
  components: {
    AuditComponent
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      auditOpenShopInfo: {
        shops: [],
        total: 0,
        records: 1,
        conditions: {
          page: 1,
          row: 10,
          AuditOpenShopsId: '',
          userName: '',
          auditLink: ''
        },
        orderInfo: {}
      }
    }
  },
  created() {
    this._listAuditOpenShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listAuditOpenShops(val, this.DEFAULT_ROWS)
    },
    async _listAuditOpenShops(page, rows) {
      this.auditOpenShopInfo.conditions.page = page
      this.auditOpenShopInfo.conditions.row = rows

      try {
        const res = await queryNeedAuditShop(this.auditOpenShopInfo.conditions)
        this.auditOpenShopInfo.total = res.total
        this.auditOpenShopInfo.records = res.records
        this.auditOpenShopInfo.shops = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAuditOpenShopModel(auditOrder) {
      this.$confirm('请确认是否继续该操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auditOpenShopInfo.orderInfo = auditOrder
        this.$refs.auditComponent.open()
      }).catch(() => {
        return false
      })
    },
    async _auditOrderInfo(auditInfo) {
      auditInfo.shopId = this.auditOpenShopInfo.orderInfo.shopId
      auditInfo.storeId = this.auditOpenShopInfo.orderInfo.storeId

      try {
        const res = await auditShop(auditInfo)
        if (res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('处理成功')
        this._listAuditOpenShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('处理失败')
      }
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>